<template>
  <nav class="mall-nav" aria-label="함우리몰 빠른 메뉴">
    <router-link
      v-for="item in items"
      :key="item.label"
      :to="item.to"
      custom
      v-slot="{ href, navigate }"
    >
      <a
        :href="href"
        class="mall-nav__item"
        :class="{ 'is-active': isActive(item) }"
        :aria-current="isActive(item) ? 'page' : undefined"
        @click="navigate"
      >
        <span class="mall-nav__icon">
          <AppIcon :icon="item.icon" :size="22" />
          <span v-if="item.badge" class="mall-nav__badge">
            {{ item.badge > 99 ? '99+' : item.badge }}
          </span>
        </span>
        <span class="mall-nav__label">{{ item.label }}</span>
      </a>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { useCart } from '@/composables/useCart'
import { useWishlist } from '@/composables/useWishlist'
import {
  MALL_CART_PATH,
  MALL_HOME_PATH,
  MALL_MYPAGE_PATH,
  MALL_WISHLIST_PATH,
} from '@/constants/mall'

interface NavItem {
  label: string
  icon: string
  to: string
  badge?: number
  exact?: boolean
}

const route = useRoute()
const { productCount } = useCart()
const { wishCount } = useWishlist()

const items = computed<NavItem[]>(() => [
  { label: '홈', icon: 'mdi-home-variant-outline', to: MALL_HOME_PATH, exact: true },
  { label: '찜하기', icon: 'mdi-heart-outline', to: MALL_WISHLIST_PATH, badge: wishCount.value },
  { label: '장바구니', icon: 'mdi-cart-outline', to: MALL_CART_PATH, badge: productCount.value },
  { label: '마이페이지', icon: 'mdi-account-outline', to: MALL_MYPAGE_PATH },
])

function isActive(item: NavItem): boolean {
  if (item.to === MALL_WISHLIST_PATH) return route.path.startsWith(MALL_WISHLIST_PATH)
  if (item.to === MALL_MYPAGE_PATH) {
    return route.path.startsWith(MALL_MYPAGE_PATH) && !route.path.startsWith(MALL_WISHLIST_PATH)
  }
  if (item.exact) return route.path === item.to
  return route.path === item.to || route.path.startsWith(`${item.to}/`)
}
</script>

<style lang="scss" src="./MallBottomNav.scss"></style>
